import SOLIDSPORT_API_PATHS from '../../constants/solidsport_api_paths.constans'
import { TimelineObject } from '../../interfaces'
import ApiEndpoint, { ApiResponse } from '../../network/ApiEndpoint'

export const getPastGameScheduleContent = async ({
  slug,
  page,
  perPageCount
}: {
  slug: string
  page: number
  perPageCount: number
}) => {
  // https://solidsport.com/api/play_v1/timeline_objects/collections/past_games?company=tullingetp-herrar&page=1&per_page=10
  try {
    const resultResponse: ApiResponse = await ApiEndpoint.call({
      path: SOLIDSPORT_API_PATHS.TIMELINE_OBJECTS.COLLECTIONS.PAST_GAMES,
      params: {
        company: slug,
        per_page: perPageCount,
        page,
        include_games_without_livestreams: true
      }
    })
    const responseData = await resultResponse
    const mapped = mapPastGameSchedulelResponse(responseData.data)
    return { data: mapped, totalCount: responseData.totalCount }
  } catch (e) {
    console.log(e)
    // @ts-ignore
    throw new Error(e.message)
  }
}

export const mapPastGameSchedulelResponse = (apiResponse: TimelineObject[]) =>
  apiResponse.map((game: TimelineObject) => ({
    id: game.ident,
    channelName: game?.display_company.name,
    channelSlug:
      game?.display_company.subdomain || game?.event?.company?.subdomain,
    label: game?.event?.name || game?.sport?.name,
    labelSlug: game?.event?.company?.subdomain,
    startTime: game.start_at,
    hasLivestream: game.has_livestream,
    hasReplay: game.is_replay,
    hasBeenPlayed: true,
    showResult: game.show_results,
    highlightSlug: game.highlight_slug,
    event: game.event,
    homeTeam: {
      name: game.home_team.name,
      slug: game.home_team.slug,
      logo: game.home_team.badge_image.sm,
      score: game.home_score === null ? 0 : game.home_score
    },
    awayTeam: {
      name: game.away_team.name,
      slug: game.away_team.slug,
      logo: game.away_team.badge_image.sm,
      score: game.away_score === null ? 0 : game.away_score
    },
    rootDomain: game.root_level_domain,
    displayChannelSlug: game.display_company.subdomain
  }))
